/* Anemoia — the "Need a hand?" FAQ pop-up.

   SELF-CONTAINED (see history below) + ENGAGEMENT-TIMED. Earlier versions anchored to the chat
   launcher (<shopify-agent> shadow DOM), which mounts late / behind a closed root / never in a
   backgrounded tab — so the pop-up was invisible on real devices. This version depends on NOTHING
   but our own document: a fixed editorial card, pinned just above where the chat launcher sits.

   TIMING — why not a plain timer: a help nudge that fires on arrival reads like an ad; fired at the
   moment of consideration it reads like a concierge. So the FIRST appearance waits for real
   engagement, all three true at once:
     1. shopping     — viewed >= 2 product pages, OR ~75s around the site
     2. after welcome — never before the newsletter popup has had its moment (it captures the email)
     3. settled       — ~14s on the current page, so it never pops the instant a page loads
   After that first, well-timed appearance it may recur on a calm cadence (long gaps, max 3/session).
   It always waits out the newsletter popup / cookie banner / social-proof ticker, and the × — or
   acting on it — stops it for the session. Never on the FAQ page, never in the theme editor. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  if (/\/pages\/faq/.test(location.pathname)) return;

  var FAQ_URL    = '/pages/faq';
  var FIRST_POLL = 8000;     // first engagement check after arrival
  var RETRY_MS   = 8000;     // re-check this often until engaged / clear (no appearance used)
  var VISIBLE_MS = 11000;    // how long each appearance holds before auto-hiding
  var GAP_MIN    = 150000;   // min gap between appearances (2.5 min)
  var GAP_VAR    = 90000;    // + up to 1.5 min jitter
  var MAX        = 3;        // appearances per session

  var N_KEY = 'anfaq_n', T_KEY = 'anfaq_next', OFF_KEY = 'anfaq_off',
      T0_KEY = 'anfaq_t0', PV_KEY = 'anfaq_pv';

  function ssGet(k, d) { try { var v = sessionStorage.getItem(k); return v == null ? d : v; } catch (e) { return d; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function getN()   { return parseInt(ssGet(N_KEY, '0'), 10) || 0; }
  function setN(n)  { ssSet(N_KEY, n); }
  function off()    { return !!ssGet(OFF_KEY, ''); }
  function setOff() { ssSet(OFF_KEY, '1'); }
  function nextAt() { return parseInt(ssGet(T_KEY, '0'), 10) || 0; }
  function schedule(){ ssSet(T_KEY, Date.now() + GAP_MIN + Math.random() * GAP_VAR); }

  // --- engagement signals (persist across page views within the session) ---
  if (!ssGet(T0_KEY, '')) ssSet(T0_KEY, Date.now());
  var sessionStart = parseInt(ssGet(T0_KEY, Date.now()), 10) || Date.now();
  if (/\/products\//.test(location.pathname)) ssSet(PV_KEY, (parseInt(ssGet(PV_KEY, '0'), 10) || 0) + 1);
  var pageStart = Date.now();

  function productViews() { return parseInt(ssGet(PV_KEY, '0'), 10) || 0; }
  function sessionAge()   { return Date.now() - sessionStart; }
  function pageDwell()    { return Date.now() - pageStart; }
  function welcomeSeen()  { try { return !!localStorage.getItem('av_welcome'); } catch (e) { return false; } }

  function engagedEnough() {
    var shopping     = productViews() >= 2 || sessionAge() >= 75000;
    var afterWelcome = welcomeSeen()  || sessionAge() >= 110000;   // never upstage the welcome offer
    var settled      = pageDwell()    >= 14000;                    // never pop on arrival
    return shopping && afterWelcome && settled;
  }

  function isVisible(el) { return !!(el && el.offsetParent !== null && el.getClientRects().length); }
  function anyVisible(sel){ var e = document.querySelectorAll(sel); for (var i = 0; i < e.length; i++) if (isVisible(e[i])) return true; return false; }
  function coveringModal() {
    try {
      var el = document.elementFromPoint((window.innerWidth || 0) / 2, (window.innerHeight || 0) / 2);
      while (el && el !== document.body && el !== document.documentElement) {
        if (el.classList && el.classList.contains('anfaq')) return false;
        var c = getComputedStyle(el);
        if ((c.position === 'fixed' || c.position === 'sticky') && (parseInt(c.zIndex, 10) || 0) >= 100
            && el.getBoundingClientRect().width * el.getBoundingClientRect().height > (window.innerWidth * window.innerHeight) * 0.4) return true;
        el = el.parentElement;
      }
    } catch (e) {}
    return false;
  }
  function busy() {
    if (anyVisible('[class*="shopify-pc__banner"]')) return true; // cookie / privacy consent
    if (anyVisible('.aw-ov.in')) return true;                     // newsletter popup
    if (document.querySelector('.aht.in')) return true;           // social-proof ticker
    return coveringModal();
  }

  function css() {
    if (document.getElementById('anfaq-css')) return;
    var s = document.createElement('style');
    s.id = 'anfaq-css';
    s.textContent = [
      '.anfaq{position:fixed;right:22px;bottom:96px;z-index:2147483000;width:290px;max-width:calc(100vw - 32px);',
      'background:#f7f4ef;color:#1f1713;border:1px solid #e3ddd2;border-radius:4px;',
      'box-shadow:0 16px 46px rgba(20,14,10,.20);padding:17px 18px 16px;',
      'opacity:0;transform:translateY(10px);transition:opacity .45s ease,transform .45s cubic-bezier(.16,1,.3,1);',
      'pointer-events:none;font-family:var(--font-body-family),-apple-system,Helvetica,Arial,sans-serif;}',
      '.anfaq.in{opacity:1;transform:none;pointer-events:auto;}',
      '.anfaq__x{position:absolute;top:8px;right:9px;background:none;border:none;cursor:pointer;',
      'color:#8a7d70;font-size:19px;line-height:1;padding:5px 7px;}',
      '.anfaq__x:hover{color:#1f1713;}',
      '.anfaq__eyebrow{margin:0 0 8px;font-size:10px;font-weight:500;letter-spacing:.22em;',
      'text-transform:uppercase;color:#8c6e4a;}',
      '.anfaq__txt{margin:0 0 13px;font-size:13.5px;line-height:1.55;color:#4c4540;padding-right:8px;}',
      '.anfaq__cta{display:inline-block;font-size:11px;font-weight:500;letter-spacing:.16em;text-transform:uppercase;',
      'color:#1f1713;text-decoration:none;border-bottom:1px solid #1f1713;padding-bottom:4px;',
      'transition:color .2s ease,border-color .2s ease;}',
      '.anfaq__cta:hover{color:#8c6e4a;border-color:#8c6e4a;}',
      '@media (max-width:749px){.anfaq{right:12px;bottom:108px;width:auto;left:12px;}}',
      '@media (prefers-reduced-motion:reduce){.anfaq{transition:opacity .2s ease;transform:none;}}'
    ].join('');
    document.head.appendChild(s);
  }

  var box = null, hideTimer = null, loopTimer = null;

  function build() {
    css();
    var el = document.createElement('div');
    el.className = 'anfaq';
    el.setAttribute('role', 'complementary');
    el.setAttribute('aria-label', 'Need a hand?');
    el.innerHTML =
      '<button class="anfaq__x" type="button" aria-label="Dismiss">&times;</button>' +
      '<p class="anfaq__eyebrow">Need a hand?</p>' +
      '<p class="anfaq__txt">Sizing, shipping, returns and care are all answered in our FAQ.</p>' +
      '<a class="anfaq__cta" href="' + FAQ_URL + '">Read the FAQ &rarr;</a>';
    el.querySelector('.anfaq__x').addEventListener('click', function (e) { e.preventDefault(); setOff(); remove(); });
    el.querySelector('.anfaq__cta').addEventListener('click', setOff);
    document.body.appendChild(el);
    return el;
  }
  function remove() { if (box) { box.classList.remove('in'); var b = box; setTimeout(function () { if (b) b.remove(); }, 500); box = null; } }

  function present() {
    if (box) return;
    box = build();
    requestAnimationFrame(function () { if (box) box.classList.add('in'); });
    setTimeout(function () { if (box) box.classList.add('in'); }, 30);   // fallback if rAF throttled
    setN(getN() + 1);
    schedule();
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { remove(); armLoop(); }, VISIBLE_MS);
  }

  function maybeShow() {
    if (off() || getN() >= MAX) return;
    if (document.hidden || busy()) { clearTimeout(loopTimer); loopTimer = setTimeout(maybeShow, RETRY_MS); return; }
    // The FIRST appearance must earn its place — hold until the visitor is genuinely engaged.
    if (getN() === 0 && !engagedEnough()) { clearTimeout(loopTimer); loopTimer = setTimeout(maybeShow, RETRY_MS); return; }
    present();
  }
  function armLoop() {
    clearTimeout(loopTimer);
    if (off() || getN() >= MAX) return;
    loopTimer = setTimeout(maybeShow, Math.max(1000, nextAt() - Date.now()));
  }

  function boot() {
    if (off() || getN() >= MAX) return;
    if (getN() === 0 && !nextAt()) loopTimer = setTimeout(maybeShow, FIRST_POLL);   // then re-polls until engaged
    else armLoop();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
